<template>
  <div v-if="visible">
    <div :style="{paddingBottom: '20px'}">{{ value.explain }}</div>
    <div :style="{fontSize: '17px',lineHeight: '35px', marginBottom:'15px',backgroundColor: '#bfbfbf38',borderRadius: '5px'}">
      <div
        id="choiceId"
        class="ql-editor"
        v-html="value.option[0].title"
        :style="{fontSize: '17px',lineHeight: '35px'}"
      ></div>
    </div>
    <div
      v-for="(item,index) in value.option[0].questionList"
      :key="index"
      :style="{paddingTop: '10px',paddingRight:'30px'}"
    >
      <a-radio-group
        :style="{width:'100%'}"
        v-model="item.result"
        @change="onChange"
      >
        <!-- <span>{{ index + 1 }}.</span> -->
        <a-row :gutter="48">
          <a-col
            :span="1"
            :style="{fontSize: '17px',color: 'black'}"
          >
            <span>{{ index + 1 }}.</span>
          </a-col>
          <a-col
            :span="5"
            v-for="(items, index2) in item.choiceList"
            :key="index2"
            :style="{paddingBottom: '10px'}"
          >
            <a-radio :value="items.title"><span :style="{fontSize: '17px',color: 'black'}">{{ items.title }} . {{ items.content }}</span></a-radio>
          </a-col>
        </a-row>
      </a-radio-group>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
export default {
  name: 'ChoiceForm',
  data () {
    return {
      visible: false,
      value: {}
    }
  },
  created () {
    // console.log('数据详情：' + JSON.stringify(this.value))
    // var reg = new RegExp('_', 'g')
    // this.value.option[0].title = this.value.option[0].title.replace(reg, '<input type="text" disabled class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>')
  },
  mounted () {
    // var questionDom = document.getElementById('choiceId')
    // var inputElements = questionDom.getElementsByTagName('input')
    // var inputElementsCount = inputElements.length
    // for (var i = 0; i < inputElementsCount; i++) {
    //   if (this.value.option[0].questionList[i].result !== '') {
    //     const choiceList = this.value.option[0].questionList[i].choiceList
    //     for (var j = 0; j < choiceList.length; j++) {
    //       if (choiceList[j].title === this.value.option[0].questionList[i].result) {
    //         inputElements[i].value = choiceList[j].content
    //       }
    //     }
    //   } else {
    //     inputElements[i].placeholder = (i + 1) + '.选择答案'
    //   }
    // }
  },
  methods: {
    handleOpen (value) {
      this.visible = true
      var reg = new RegExp('_', 'g')
      value.option[0].title = value.option[0].title.replace(reg, '<input type="text" disabled class="ant-input" style="width:110px;color: #1890ff;border-color: #1890ff; font-size: 17px"/>')
      this.value = value
      setTimeout(() => {
        this.handelData()
      }, 10)
    },
    handelData () {
      var questionDom = document.getElementById('choiceId')
      var inputElements = questionDom.getElementsByTagName('input')
      var inputElementsCount = inputElements.length
      for (var i = 0; i < inputElementsCount; i++) {
        if (this.value.option[0].questionList[i].result !== '') {
          const choiceList = this.value.option[0].questionList[i].choiceList
          for (var j = 0; j < choiceList.length; j++) {
            if (choiceList[j].title === this.value.option[0].questionList[i].result) {
              inputElements[i].value = choiceList[j].content
            }
          }
        } else {
          inputElements[i].placeholder = (i + 1) + '.选择答案'
        }
      }
    },
    handleClose () {
      this.visible = false
    },
    onChange () {
      var questionDom = document.getElementById('choiceId')
      var inputElements = questionDom.getElementsByTagName('input')
      var inputElementsCount = inputElements.length
      for (var i = 0; i < inputElementsCount; i++) {
        if (this.value.option[0].questionList[i].result !== '') {
          const choiceList = this.value.option[0].questionList[i].choiceList
          for (var j = 0; j < choiceList.length; j++) {
            if (choiceList[j].title === this.value.option[0].questionList[i].result) {
              inputElements[i].value = choiceList[j].content
            }
          }
        } else {
          inputElements[i].placeholder = (i + 1) + '.选择答案'
        }
      }
      // console.log('data' + JSON.stringify(this.value))
      this.$emit('resultChange', this.value)
    }
  }
}
</script>
